export function transformListObject(list) {
  return list?.map((field) => {
    return {
      [field.value]: field.label,
      [`${field.value}_status`]: String(field.visibility),
    };
  });
}
